import React, { FC } from 'react'
import { BlackParagraph } from 'components/atoms/Paragraph'
import { Checkbox } from 'components/molecules/Checkbox'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const LogsFilter: FC<{ actions: string[]; onChangeFilter: (option: string) => void }> = ({
                                                                                           actions,
  onChangeFilter,
}) => {
  const [t] = useTranslation()
  return (
    <Container>
      {[
        { label: t('page.activity.filter.login'), option: 'AdminUser:ADD' },
        { label: t('page.activity.filter.logout'), option: 'AdminUser:DELETE' },
        { label: t('page.activity.filter.qr'), option: 'Autoconfig:ADD' },
        { label: t('page.activity.filter.updateUser'), option: 'Roster:UPDATE' },
        { label: t('page.activity.filter.createInfoMessage'), option: 'InfoMessage:ADD' },
        { label: t('page.activity.filter.updateInfoMessage'), option: 'InfoMessage:UPDATE' },
        { label: t('page.activity.filter.createFeatureGroup'), option: 'FeatureGroup:ADD' },
        { label: t('page.activity.filter.updateFeatureGroup'), option: 'FeatureGroup:UPDATE' },
      ].map(({ option, label }) => (
        <FilterItem key={option}>
          <BlackParagraph text={label} />
          <Checkbox
            style={{ marginLeft: '4px' }}
            checked={actions.includes(option)}
            onToggle={() => onChangeFilter(option)}
          />
        </FilterItem>
      ))}
    </Container>
  )
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`

const FilterItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export { LogsFilter }
